export default __webpack_public_path__ + "slices/main/assets/public/media/news-card-1@2x.4605d396e6b957b527d1d5b88e5754d3.png";